import { Alert, Button, CircularProgress } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import InputField from "components/Input/InputField";
import { API_URL } from "const/constants";
import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

export default function Forgot() {
  const [data, setData] = useState({});
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prevState) => ({ ...prevState, [name]: value }));
  };
  const [message, setMessage] = useState();

  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage();
    mutate(data);
  };

  const postData = async (payload) => {
    delete axios.defaults.headers.common["Authorization"];
    return await axios.post(`${API_URL}/forgot-password`, payload);
  };
  const { mutate, isLoading } = useMutation(postData, {
    onSuccess(response) {
      setMessage(response?.data?.message);
      setData({
        email: "",
      });
      toast.success(
        response?.data?.message ||
          "An email has been sent to your email address with instructions on how to reset your password."
      );
    },
    onError(err) {
      toast.error(err?.response?.data?.errorMessage ?? err?.response?.data?.message ?? "Error");
    },
  });

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="mx-auto px-4 h-full w-full">
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-4/12 px-4">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-app-surface-hover border-0">
              <div className="rounded-t mb-0 px-6 py-6">
                <div className="text-center mb-3">
                  <h3 className="text-app-text-muted text-xl font-bold uppercase">
                    Forgot Password?
                  </h3>
                </div>

                <hr className="mt-6 border-b-1 border-app-border" />
              </div>
              <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
                  <div className="relative w-full mb-3">
                    <InputField
                      label="Email"
                      placeholder="Type your registered Email"
                      name="email"
                      required
                      type="email"
                      value={data?.email}
                      onChange={handleInputChange}
                    />
                  </div>
                  {message && <Alert severity="success">{message}</Alert>}

                  <div className="text-center mt-6">
                    <Button
                      variant="contained"
                      className="w-full"
                      type="submit"
                      disabled={isLoading}
                      startIcon={isLoading && <CircularProgress size={15} />}
                    >
                      Reset Password
                    </Button>
                  </div>
                </form>
              </div>
            </div>
            <div className="flex flex-wrap mt-6 relative">
              <div className="w-full text-center">
                <Link to="/" className="text-slate-200">
                  <small>Go back to login page?</small>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
